<template>
  <div class="container">
    <Nav></Nav>
    <div class="banner"></div>
    <div class="warp" @mouseleave="moveOut">
      <div class="nav">
        <div class="cate">
          <div
            :class="[typeIndex == 1 ? 'navActive' : '']"
            @mouseover="moveIn(1)"
          >
            住房城乡建设
          </div>
          <div
            :class="[typeIndex == 2 ? 'navActive' : '']"
            @mouseover="moveIn(2)"
          >
            交通运输
          </div>
          <div
            :class="[typeIndex == 3 ? 'navActive' : '']"
            @mouseover="moveIn(3)"
          >
            食品安全
          </div>
          <div
            :class="[typeIndex == 4 ? 'navActive' : '']"
            @mouseover="moveIn(4)"
          >
            医疗卫生
          </div>
          <!-- <div :class="[typeIndex==5?'navActive':'']" @mouseover="moveIn(5)">中央企业</div> -->
          <!-- <div :class="[typeIndex==5?'navActive':'']" @mouseover="moveIn(5)">职业教育</div> -->
          <!-- <div
            :class="[typeIndex == 6 ? 'navActive' : '']"
            @mouseover="moveIn(6)"
          >
            环境保护
          </div> -->
          <div
            :class="[typeIndex == 7 ? 'navActive' : '']"
            @mouseover="moveIn(7)"
          >
            安全生产
          </div>
          <div
            :class="[typeIndex == 8 ? 'navActive' : '']"
            @mouseover="moveIn(8)"
          >
            纪检监察
          </div>
          <div
            :class="[typeIndex == 9 ? 'navActive' : '']"
            @mouseover="moveIn(9)"
          >
            其 他
          </div>
        </div>
      </div>
      <div class="cateSecond" v-if="seList.length > 0">
        <div class="swaper-box">
          <swiper :options="swiperOption1">
            <swiper-slide v-for="(item, index) in seList" :key="index">
              <div
                @click="toPage(item.Id)"
                :class="[seIndex == item.Id ? 'secondActive' : '']"
              >
                <p>{{ item.Name }}</p>
              </div>
            </swiper-slide>
          </swiper>
          <div
            v-show="seList.length > 4"
            class="swiper-button-next swiper-button-next-prs"
          ></div>
          <div
            v-show="seList.length > 4"
            class="swiper-button-prev swiper-button-prev-prs"
          ></div>
        </div>
        <!-- <div v-for="(item,index) in seList" :key="index" :class="[seIndex==item.Id?'secondActive':'']" @click="toPage(item.Id)"><p >{{item.Name}}</p></div> -->
      </div>
    </div>
    <div class="con">
      <div class="left">
        <p class="title">{{ data.Name }}</p>
        <hr />
        <img class="spec" :src="data.LogoUrl" alt="" />
        <p class="left-con" v-html="data.Content"></p>
        <p
          class="link"
          v-if="data.TargetProjectName"
          @click="toOtherLink(data.TargetProjectUrl)"
        >
          {{ data.TargetProjectName }}>>>
        </p>
      </div>
      <div class="right">
        <div v-if="data.XcxUrl">
          <p class="about">相关应用推荐</p>
          <img class="code" :src="data.XcxUrl" alt="" />
          <p class="wei">— 微信扫一扫 —</p>
          <p class="use">使用小程序<span></span></p>
        </div>
        <div v-if="data.GzhUrl">
          <p class="about">相关应用推荐</p>
          <img class="code" :src="data.GzhUrl" alt="" />
          <p class="wei">— 微信扫一扫 —</p>
          <p class="use">关注公众号<span></span></p>
        </div>
        <div v-if="data.AppUrl">
          <p class="about">相关应用推荐</p>
          <img class="code" :src="data.AppUrl" alt="" />
          <p class="wei">— 微信扫一扫 —</p>
          <p class="use">使用APP<span></span></p>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Nav from '@/components/topNav.vue';
import Footer from '@/components/footer.vue';
export default {
  components: {
    Nav,
    Footer
  },
  data () {
    return {
      list: [], // 获取所有数据
      typeIndex: 1, // 行业类型
      seList: [], // 二级行业
      seIndex: '', // 二级行业Id
      liveList: [], // 住建  1
      trafficList: [], // 交通  2
      fdaList: [], //  食品  3
      medList: [], //  医疗  4
      zhList: [], //  职业  5
      huanList: [], //  环境  6
      anList: [], //   安全  7
      jiList: [], //  纪检  8
      otherList: [], //   其他  9
      data: '', // 当前显示数据
      type: '', // 接受到的type
      swiperOption1: {
        slidesPerView: 4,
        spaceBetween: 20,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next-prs',
          prevEl: '.swiper-button-prev-prs'
        }
      }
    }
  },
  watch: {
    // 利用watch方法检测路由变化：
    $route: function (to, from) {
      // 拿到目标参数 to.query.id 去再次请求数据接口
      this.type = to.query.type

      //清空数据
      this.liveList = []
      this.trafficList = []
      this.fdaList = []
      this.medList = []
      this.zhList = []
      this.huanList = []
      this.anList = []
      this.jiList = []
      this.otherList = []

      this.loadData()
    }
  },
  mounted () {
    this.type = this.$route.query.type
    this.loadData()
  },
  methods: {
    loadData () {
      let that = this
      this.axios({
        methods: 'GET',
        url: '/api/ProductSys/GetProducts'
      })
        .then((result) => {
          if (result.data.success) {
            let arr = result.data.data
            that.list = arr
            arr.forEach(function (item, index) {
              if (item.IndustryType == 1) {
                that.liveList.push(item)
              } else if (item.IndustryType == 2) {
                that.trafficList.push(item)
              } else if (item.IndustryType == 3) {
                that.fdaList.push(item)
              } else if (item.IndustryType == 4) {
                that.medList.push(item)
              } else if (item.IndustryType == 5) {
                that.zhList.push(item)
              } else if (item.IndustryType == 6) {
                that.huanList.push(item)
              } else if (item.IndustryType == 7) {
                that.anList.push(item)
              } else if (item.IndustryType == 8) {
                that.jiList.push(item)
              } else if (item.IndustryType == 9) {
                that.otherList.push(item)
              }
            })
            if (that.$route.query.type && that.$route.query.id) {
              let type = that.$route.query.type
              let id = that.$route.query.id
              if (type == 1) {
                that.seList = that.liveList
              } else if (type == 2) {
                that.seList = that.trafficList
              } else if (type == 3) {
                that.seList = that.fdaList
              } else if (type == 4) {
                that.seList = that.medList
              } else if (type == 5) {
                that.seList = that.zhList
              } else if (type == 6) {
                that.seList = that.huanList
              } else if (type == 7) {
                that.seList = that.anList
              } else if (type == 8) {
                that.seList = that.jiList
              } else if (type == 9) {
                that.seList = that.otherList
              }
              that.typeIndex = type
              that.seIndex = id
            } else if (that.type) {
              let type = that.type
              if (type == 1) {
                that.seList = that.liveList
              } else if (type == 2) {
                that.seList = that.trafficList
              } else if (type == 3) {
                that.seList = that.fdaList
              } else if (type == 4) {
                that.seList = that.medList
              } else if (type == 5) {
                that.seList = that.zhList
              } else if (type == 6) {
                that.seList = that.huanList
              } else if (type == 7) {
                that.seList = that.anList
              } else if (type == 8) {
                that.seList = that.jiList
              } else if (type == 9) {
                that.seList = that.otherList
              }
              that.typeIndex = type
              that.seIndex = that.seList[0].Id
            } else {
              that.seList = that.liveList
              that.seIndex = that.liveList[0].Id
            }
            this.toPage(that.seIndex)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    moveIn (index) {
      this.typeIndex = index
      if (index == 1) {
        this.seList = this.liveList
      } else if (index == 2) {
        this.seList = this.trafficList
      } else if (index == 3) {
        this.seList = this.fdaList
      } else if (index == 4) {
        this.seList = this.medList
      } else if (index == 5) {
        this.seList = this.zhList
      } else if (index == 6) {
        this.seList = this.huanList
      } else if (index == 7) {
        this.seList = this.anList
      } else if (index == 8) {
        this.seList = this.jiList
      } else {
        this.seList = this.otherList
      }
    },
    toPage (id) {
      // console.log(id, 'idddd')
      let that = this
      this.seIndex = id
      that.list.forEach(function (item, index) {
        if (item.Id == id) {
          that.data = item
        }
      })
      // console.log(this.data, "data");
    },
    moveOut () {
      this.typeIndex = this.data.IndustryType
      this.moveIn(this.typeIndex)
    },
    toOtherLink (link) {
      // console.log(link, "link");
      // Window.open(link)
      window.open(link, '_blank')
    }
  }
}
</script>

<style scoped>
.container {
  background-color: #f7f7f7;
}
.banner {
  width: 100%;
  height: 300px;
  background: url("../assets/images/proproducts.png") no-repeat center;
  overflow: hidden;
  background-size: 100% 100%;
}
.bread {
  width: 100%;
  height: 56px;
  background: #fbfbfb;
}
.bread div {
  width: 1200px;
  margin: 0px auto;
}
.bread .bread-mulu {
  width: 175px;
  float: left;
  line-height: 56px;
  display: flex;
  justify-content: space-between;
}
.bread .bread-mulu img {
  width: 12px;
  height: 12px;
  align-self: center;
  vertical-align: 0px;
}
.bread .bread-mulu span {
  display: inline;
  width: 0px; /*  宽高设置为0，很重要，否则达不到效果 */
  height: 0px;
  border: 5px solid #727272;
  border-top-color: transparent; /*设置透明背景色*/
  border-right-color: transparent;
  border-bottom-color: transparent;
  align-self: center;
  margin-right: -15px;
}
.bread .bread-mulu .br-name {
  color: #b00000;
}
.nav {
  width: 100%;
  background-color: #fbfbfb;
}
.nav .cate {
  width: 1200px;
  height: 60px;
  background: #fbfbfb;
  margin: 0px auto 0px;
  display: flex;
  justify-content: space-between;
}
.nav .cate div {
  text-align: center;
  /* background-color: orange; */
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  line-height: 60px;
  cursor: pointer;
}
.nav .cate div:last-child {
  /* background-color: orange; */
  width: 70px;
}
.navActive {
  /* background: #B00000; */
  color: #b00000 !important;
  background-image: url("../assets/images/newscenter/nav-top.png");
  background-repeat: no-repeat;
  background-position: center 51px;
  background-size: 80px 8px;
}
.cateSecond {
  width: 1200px;
  /* background: #fff; */
  margin: 26px auto 0px;
  /* overflow: hidden; */
  background: #f7f7f7;
  position: relative;
}
.cateSecond div {
  /* width: 280px;
    height: 88px;
    float: left;
    cursor: pointer;
    background-color: #fff;
    margin-right: 20px;
    display: flex;
    align-items: center;
    color: #333333; */
}
.cateSecond .swiper-slide {
  background: #fff;
  height: 88px;
}
.cateSecond .swiper-slide > div {
  height: 88px;
  width: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #333;
}
.cateSecond .swiper-slide > div p {
  width: 100%;
  margin: 0px 20px 0px 20px;
  letter-spacing: 1px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 24px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-align: center;
}
/* .cateSecond .swaper-box{
  position: relative;
}
.cateSecond .swiper-button-next{
  position: absolute;
  left: 1200px;
}
.cateSecond .swiper-button-prev{
  position: absolute;
  left: -20px;
  z-index: 9999;
} */
.cateSecond div p {
  /* width: 100%;
  margin: 0px 20px 0px 20px;
  letter-spacing: 1px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 24px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-align: center; */
}
.secondActive {
  background-color: #b00000 !important;
  color: #fff !important;
}
.con {
  width: 1200px;
  /* height: 800px; */
  /* background-color: orange; */
  margin: 40px auto 80px;
  display: flex;
  justify-content: space-between;
}
.con .left {
  width: 900px;
  height: 100%;
  background-color: #fff;
  text-align: center;
  padding-bottom: 100px;
  position: relative;
}
.con .right {
  width: 270px;
  height: 100%;
  /* background-color: pink; */
}
.con .left .spec {
  width: 840px;
  margin-top: 22px;
}
.con .left .title {
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  margin-top: 30px;
}
.con .left hr {
  border: none;
  /* border-top: 1px soild red; */
  border-top: 1px solid #e2e2e2;
  width: 800px;
  margin: 20px auto 0px;
}
.con .left .left-con {
  width: 840px;
  margin: 15px auto 0px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  text-align: left;
  line-height: 30px;
}
.con .left .link {
  position: absolute;
  bottom: 30px;
  left: 36px;
  color: #007aff;
  font-size: 16px;
  cursor: pointer;
}
.con .right div {
  width: 270px;
  height: 270px;
  background-color: #fff;
  text-align: center;
  overflow: hidden;
  margin-top: 20px;
}
.con .right div:first-child {
  margin-top: 0px;
}
.con .right div .about {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  margin: 16px 0px 0px 0px;
  letter-spacing: 2px;
}
.con .right div .code {
  width: 142px;
  margin: 10px 0px 0px;
}
.con .right div .wei {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  letter-spacing: 1px;
}
.con .right div .use {
  position: relative;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  letter-spacing: 1px;
  margin: 5px 0px 0px;
}
.con .right div .use span {
  position: absolute;
  display: inline-block;
  top: 10px;
  left: 94px;
  width: 82px;
  height: 9px;
  background: #b00000;
  opacity: 0.1;
}
.swiper-button-next,
.swiper-container-rtl .swiper-button-prev {
  height: 53px;
  width: 22px;
  top: 48%;
  right: -33px;
  background: url("../assets/images/right-icon.png") no-repeat;
  background-size: 100% 100%;
}
.swiper-button-prev,
.swiper-container-rtl .swiper-button-next {
  height: 53px;
  width: 22px;
  top: 48%;
  left: -33px;
  background: url("../assets/images/left-icon.png") no-repeat;
  background-size: 100% 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/proProducts.vue